export function paymentPlanAdjustConfig(getMoney, dateConvert, selectPersonClick, selectDeptClick) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: false,
    menu: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    columnBtn: false,
    searchBtn: true,
    selection: true,
    selectionWidth: 35,
    searchShow: false,
    index: true,
    indexLabel: "序号",
    indexLabelWidth: 35,
    refreshBtn: false,
    border:true,
    column: [{
        label: "项目名称",
        prop: "projectName",
        slot: true,
        search:true,
        width: 350,
      },
      {
        label: "保理合同",
        search: true,
        prop: "contractName",
        overHidden: true,
        display: false,
        hide:true,
      },
      {
        label: "付款次号",
        prop: "investStr",
        slot: true,
      },
      {
        label: "本笔实付金额",
        prop: "investShouldMoney",
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        },
        
      },
      {
        label: "款项类型",
        prop: "moneyTypeStr",
      },
      {
        label: "款项类型",
        prop: "moneyType",
        search: true,
        hide:true,
        type: "select",
        dicData: [{
            label: "资金投放",
            value: 0,
          },
          {
            label: "保证金退还",
            value: 1,
          },
        ],
        
      },
      {
        label: "计划付款日期",
        prop: "planPayDate",
        width: 150,
      },
      // {
      //   label: "付款状态",
      //   prop: "isWriteoff",
      //   formatter: (row, value, label, column) => {
      //     return value == 0 ? "未核销" : "已核销";
      //   },
      // },
      {
        label: "审批状态",
        prop: "auditStatusStr",
        
      },
      {
        label: '审批状态',
        prop: 'auditStatus',
        hide:true,
        search: true,
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=project_build_state",
        
        props: {
          label: "dictValue",
          value: "dictKey"
        }
      },
      {
        label: '日期范围',
        prop: 'timePic',
        type:'daterange',
        searchSpan:12,
        searchRange:true,
        search:true,
        hide:true
      }, 
      {
        label: "创建时间",
        prop: "createTime",
        width: 150,
      },
    ],
  }
}


export function paymentPlanAdjustAddConfig(changeMoneyType, changeCost, changeInvestMoney) {
  return {
    labelWidth: 180,
    emptyBtn: false,
    submitBtn: false,
    column: [{
        label: "付款批次",
        prop: "investBatchStr",
        formslot: true,
        span: 12,
        placeholder: "等待生成项目名称",
      },
      {
        label: "收款方银行信息",
        prop: "bankInfo",
        formslot: true,
        span: 12,
      },
      {
        label: "本批投付款金额",
        prop: "investAllMoney",
        formslot: true,
        span: 12,
        disabled: false,
      },
      {
        label: "本批次已付款金额",
        prop: "investAlreadyMoney",
        formslot: true,
        span: 12,
        disabled: false,
      },
      {
        label: "本批次剩余可放金额",
        prop: "lastMoney",
        formslot: true,
        span: 12,
      },
      {
        label: "款项类型",
        prop: "moneyType",
        type: "radio",
        disabled:false,
        span: 12,
        dicData: [{
            label: "资金投放",
            value: 0,
          },
          {
            label: "保证金退还",
            value: 1,
          },
        ],
        change: (data) => {
          changeMoneyType(data)
        },
        rules: [{
          required: true,
          message: "请选择款项类型",
          trigger: "change",
        }, ],
      },
      {
        label: "本笔付款金额",
        prop: "investMoney",
        span: 12,
        append: "元",
        disabled: false,
        display: true,
        change: (data) => {
          console.log(data)
          if (data.value != "" && data.value > 0) {
            changeInvestMoney(data.value)
            changeCost();
          }
        },
        rules: [{
          required: true,
          message: "请输入本笔付款金额",
          trigger: "change",
        }, ],
      },
      {
        label: "计划付款时间",
        type: "date",
        prop: "planPayDate",
        format: "yyyy-MM-dd",
        valueFormat: "yyyy-MM-dd",
        span: 12,
        rules: [{
          required: true,
          message: "请选择计划付款时间",
          trigger: "change",
        }, ],
      },
      {
        label: "还款日",
        prop: "rentDate",
        formslot: true,
        display: true,
        span: 12,
      },
      {
        label: "内扣明细",
        prop: "innerMoney",
        formslot: true,
        display: true,
        span: 24,
      },
      {
        label: "保证金明细",
        prop: "depositMoney",
        formslot: true,
        display: false,
        span: 24,
      },
      {
        label: "内扣合计金额",
        prop: "presentCostSum",
        formslot: true,
        display: true,
        span: 12,
      },
      {
        label: "本笔应实付金额",
        prop: "actuallPayment",
        formslot: true,
        display: true,
        span: 12,
      },
      {
        label: "支付方式",
        prop: "payType",
        type: "radio",
        span: 14,
        dicData: [{
            label: "电汇",
            value: 0,
          },
          {
            label: "银行承兑汇票",
            value: 1,
          },
          {
            label: "电商",
            value: 2,
          },
          {
            label: "其它",
            value: 3,
          },
        ],
      },
      {
        label: "补充说明",
        prop: "otherCondition",
        span: 14,
        type: "textarea",
      },
    ],
  }
}


export function detailConfig() {
  return {

    column: [{
        label: "项目名称",
        prop: "projectName",
        span: "12",
      },
      {
        label: "业务类型",
        prop: "projectTypeStr",
        span: "12",
      },
      {
        label: "收款方",
        prop: "sellerCustName",
        span: "12",
      },
      {
        label: "保理商",
        prop: "accountingEntity",
        span: "12",
      },
      {
        label: "保理合同",
        prop: "contractName",
        span: "12",
      },
      {
        label: "对应当款批次",
        prop: "investBatch",
        span: "12",
      },
      {
        label: "业务主办",
        prop: "managerUserName",
        span: "12",
      },
      {
        label: "业务协办",
        prop: "assistUserName",
        span: "12",
      }
    ]



  }
}
export function writeOffFormConfig() {
  return {


    labelWidth: 150,
    emptyBtn: false,
    submitBtn: false,
    column: [{
        label: "款项标题",
        prop: "investTitle",
        formslot: true,
        span: 14,
      },
      {
        label: "款项类型",
        prop: "moneyTypeStr",
        formslot: true,
        span: 14,
        placeholder: "等待生成项目名称",
      },
      {
        label: "应付金额",
        prop: "shouldPay",
        formslot: true,
        span: 14,
      },
      {
        label: "计划付款日期",
        prop: "planPayDate",
        formslot: true,
        span: 14,
      },
      {
        label: "客户收款账号",
        prop: "bankInfo",
        formslot: true,
        span: 14,
      },
    ],




  }
}
